/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiAgentConfigStore } from '../../axios/whatsAppAiAgentConfigStore'
import type {
	WhatsAppAiAgentConfigStoreError,
	WhatsAppAiAgentConfigStorePathParams,
	WhatsAppAiAgentConfigStoreRequest,
	WhatsAppAiAgentConfigStoreResponse,
} from '../../types/WhatsAppAiAgentConfigStore'

export const whatsAppAiAgentConfigStoreMutationKey = () =>
	[{ url: '/campaigns/:campaignId/whatsapp-ai-config' }] as const

export type WhatsAppAiAgentConfigStoreMutationKey = ReturnType<typeof whatsAppAiAgentConfigStoreMutationKey>

export type WhatsAppAiAgentConfigStoreVariables = {
	campaignId: WhatsAppAiAgentConfigStorePathParams['campaignId']
	data: WhatsAppAiAgentConfigStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::store */
export function useWhatsAppAiAgentConfigStore<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppAiAgentConfigStoreResponse,
		AxiosError<WhatsAppAiAgentConfigStoreError>,
		WhatsAppAiAgentConfigStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppAiAgentConfigStoreMutationKey(),
		mutationFn: ({ campaignId, data }: WhatsAppAiAgentConfigStoreVariables) =>
			whatsAppAiAgentConfigStore(campaignId, data, config).then(res => res.data),
		...options,
	})
}
